import {IExperienceFormErrorMessages} from '@/dictionaries/pages/experience/types';
import {Experience} from '@/services/experienceTypes';
import * as yup from 'yup';

export interface ExperienceForm {
  villaBooking: {
    label: string | null;
    value: string | null;
  };
  option: {
    label: string;
    value: string;
  };
  dates: {
    start: Date | null;
    end: Date | null;
  };
  time: {
    label: string;
    value: string;
  };
  language: {
    label: string;
    value: string;
  };
  quantities: {
    adults: number;
    children: number;
    infants: number;
  };
}

export function getTranslatedSchema(
  dict: IExperienceFormErrorMessages,
  exp: Experience,
) {
  return yup.object().shape({
    villaBooking: yup.object().shape({
      label: yup.string().default(''),
      value: yup.string().default(''),
    }),
    option: yup.object().shape({
      label: yup.string().required(),
      value: yup.string().required(),
    }),
    dates: yup
      .object()
      .shape({
        start: yup.date().default(null).nullable(),
        end: yup.date().default(null).nullable(),
      })
      .test('is-null', dict.date, function (value) {
        const {start} = this.resolve(value);
        return start !== null;
      }),
    time: yup.object().shape({
      label: yup.string().required(),
      value: yup.string().required(),
    }),
    language: yup.object().shape({
      label: yup.string().required(),
      value: yup.string().required(),
    }),
    quantities: yup
      .object({
        adults: yup.number().required(),
        children: yup.number().required(),
        infants: yup.number().required(),
      })
      .test('is-valid-total', dict.participants, function (value) {
        const {adults, children, infants} = this.resolve(value);
        const total = adults + children + infants;
        return total > exp.minParticipants - 1;
      }),
  });
}
